export default __webpack_public_path__ + "static/partners-list-4100bff04ed47fdb093cb2960b862133.png";